import * as React from "react"

const isTypingTarget = (el: EventTarget | null): boolean => {
  if (!(el instanceof HTMLElement)) return false
  const tag = el.tagName
  return tag === "INPUT" || tag === "TEXTAREA" || el.isContentEditable
}

/**
 * Focus `ref.current` when the user presses `/` outside another input.
 * Idiomatic linear-style keyboard hint for a page's primary search box.
 */
export function useSlashShortcut(ref: React.RefObject<HTMLElement | null>): void {
  React.useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key !== "/") return
      if (e.metaKey || e.ctrlKey || e.altKey) return
      if (isTypingTarget(e.target)) return
      e.preventDefault()
      ref.current?.focus()
    }
    window.addEventListener("keydown", handler)
    return () => {
      window.removeEventListener("keydown", handler)
    }
  }, [ref])
}
